import "rxjs/Rx";

import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Response } from "@angular/http";

export interface OrgModel {
  errorMsg: string;
  data: Array<any>;
}
@Injectable()
export class OrganizationserviceService {
  public static OrgApiUrls = {
    OrgnizationListUrl: "",
    OrganizationPendingTAA: "",
    SaveRole: ""
  };
  public selectedOrgDetails: any;
  public user: any;

  constructor(private http: HttpClient) { }

  getTermAndCondition() {
    return this.http.get(`/api/CheckTermsConds/getTermsCond`, {
      responseType: "json"
    });
  }

  getOrgId(mdmId: string) {
    return this.http.get<OrgModel>("/api/Mdmid/getMdmIdById", {
      params: {
        mdmId: mdmId
      },
      observe: "response"
    });
  }

  getAttestedTermAndCondition(checkUser: any) {
    return this.http.get("/api/AttestedTermsConds/count", {
      params: {
        TERM_COND_ID: checkUser.TERM_COND_ID,
        USER_ID: checkUser.USER_ID,
        ORGANIZATION_ID: checkUser.ORGANIZATION_ID
      },
      observe: "response"
    });
  }

  postUserAttestedTermAndCondition(postAttestedUser: any) {
    return this.http.post(
      "/api/AttestedTermsConds/addAttestedRecord",
      postAttestedUser,
      { observe: "response" }
    );
  }

  SaveRole(req) {
    return this.http
      .post(OrganizationserviceService.OrgApiUrls.SaveRole, req)
      .map((res: Response) => {
        return res.json();
      })
      .catch((err: Response) => {
        return new Promise((resolve, reject) => reject(err));
      });
  }
}



// WEBPACK FOOTER //
// ./client/views/services/organizationservice.service.ts